module.exports = __webpack_public_path__ + "img/sendgrid.cb19554d.png";